
<div v-show="show" class="advanced-popover-menu px-3 py-2">
    <component :is="activeMenuOption" />
</div>
